export interface BaseObjectCount<TGroup> {
    value: number;
    date: Date;
    group?: TGroup;
}
